import { useEffect, useState, type RefObject } from 'react';

export function useContainerHeight(ref: RefObject<HTMLElement | null>) {
  const [height, setHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    setHeight(el.getBoundingClientRect().height);

    if (typeof ResizeObserver === 'undefined') return;

    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const borderBoxSize = entry.borderBoxSize as
          | ReadonlyArray<ResizeObserverSize>
          | ResizeObserverSize
          | undefined;
        const size = Array.isArray(borderBoxSize) ? borderBoxSize[0] : borderBoxSize;
        setHeight(size?.blockSize ?? entry.contentRect.height);
      }
    });
    observer.observe(el, { box: 'border-box' });

    return () => observer.disconnect();
  }, [ref]);

  return height;
}
